import React from 'react';
import PropTypes from 'prop-types';

import { Rnd } from 'react-rnd';

import CPipeAssessmentsAnalysis from '../../containers/CPipeAssessmentsAnalysis/CPipeAssessmentsAnalysis';
import { IconButton, Typography, Box } from '@mui/material';
import AddIcon from '@mui/icons-material/Add';
import RemoveIcon from '@mui/icons-material/Remove';
import CloseIcon from '@mui/icons-material/Close';
import DragIndicatorIcon from '@mui/icons-material/DragIndicator';

const classNames = require('classnames');

const resizeEnable = {
   bottom: false,
   bottomLeft: false,
   bottomRight: false,
   left: false,
   right: false,
   top: false,
   topLeft: false,
   topRight: false,
};

export default class FloatingDataComponent extends React.Component {

   static get propTypes() {
      return {
         onClose: PropTypes.func,
      };
   }

   constructor(props) {
      super(props);

      this.collapse = this.collapse.bind(this);
      this.expand = this.expand.bind(this);

      this.state = {
         x: 150,
         y: -50,
         divClassName: 'expand',
         pivotState: {
            rendererName: 'Table Heatmap',
            rows: ['Material'],
            cols: ['PlacementYear'],
         }
      };
   }

   collapse() {
      this.setState({
         divClassName: 'collapse'
      });
   }

   expand() {
      this.setState({
         divClassName: 'expand'
      });
   }

   render() {
      const { onClose } = this.props;

      const classes = classNames(
         'flot-drag',
         this.state.divClassName
      );

      const contentClasses = classNames(
        'dragContent',
        this.state.divClassName == 'expand' ? 'visible' : 'hidden'
      )

      const layoutVisibility = this.state.divClassName == 'expand' ? 'visible' : 'hidden';

      return (
         <Rnd
            className={classes}
            dragHandleClassName='dragHandler'
            position={{ x: this.state.x, y: this.state.y }}
            onDragStop={(e, d) => {
               this.setState({ x: d.x, y: d.y });
            }}
            enableResizing={resizeEnable}
            bounds="window"
            >

            <Box className='dragHandler'>
              <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                <DragIndicatorIcon sx={{ color: '#5a6a7a', fontSize: 20 }} />
                <Typography
                  variant="h6"
                  sx={{
                    fontWeight: 600,
                    color: '#2c3e50',
                    fontSize: '1.1rem',
                    letterSpacing: '0.3px'
                  }}
                >
                  {this.context.t('Pipe Condition Analyzer')}
                </Typography>
              </Box>
              <Box className='size-buttons'>
                <IconButton
                  size="small"
                  onClick={this.expand}
                  sx={{
                    backgroundColor: 'rgba(117, 202, 227, 0.2)',
                    '&:hover': { backgroundColor: 'rgba(117, 202, 227, 0.4)' },
                    marginRight: '4px'
                  }}
                >
                  <AddIcon sx={{ fontSize: 18, color: '#1487ae' }} />
                </IconButton>
                <IconButton
                  size="small"
                  onClick={this.collapse}
                  sx={{
                    backgroundColor: 'rgba(117, 202, 227, 0.2)',
                    '&:hover': { backgroundColor: 'rgba(117, 202, 227, 0.4)' },
                    marginRight: '4px'
                  }}
                >
                  <RemoveIcon sx={{ fontSize: 18, color: '#1487ae' }} />
                </IconButton>
                <IconButton
                  size="small"
                  onClick={onClose}
                  sx={{
                    backgroundColor: 'rgba(255, 100, 100, 0.1)',
                    '&:hover': { backgroundColor: 'rgba(255, 100, 100, 0.3)' }
                  }}
                >
                  <CloseIcon sx={{ fontSize: 18, color: '#c0392b' }} />
                </IconButton>
              </Box>
            </Box>

            <div className={contentClasses}>
               <div style={{visibility: layoutVisibility}}>
                  <CPipeAssessmentsAnalysis
                     layoutVisibility={layoutVisibility}
                  />
               </div>
            </div>

         </Rnd>
       );
   }
}

FloatingDataComponent.contextTypes = {
   t: PropTypes.func.isRequired
};
